module.exports = __webpack_public_path__ + "img/patient.f60f99d2.svg";